import { render } from "./photos.vue?vue&type=template&id=f2250c5a"
import script from "./photos.vue?vue&type=script&lang=js"
export * from "./photos.vue?vue&type=script&lang=js"

import exportComponent from "/Users/twchou/workspace/work/csunion/highschool_website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__